import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isArray as D } from "./code-utils.js";
var ge = /*#__PURE__*/function () {
  function ge() {
    _classCallCheck(this, ge);
  }
  _createClass(ge, [{
    key: "ef",
    value: function ef() {}
  }, {
    key: "ff",
    value: function ff() {}
  }, {
    key: "Ja",
    value: function Ja(t) {}
  }], [{
    key: "nf",
    value: function nf(t, e) {
      if (t && e) if (t = t.toLowerCase(), D(e.cf)) {
        for (var r = 0; r < e.cf.length; r++) if (-1 !== t.indexOf(e.cf[r].toLowerCase())) return e.identity;
      } else if (-1 !== t.indexOf(e.cf.toLowerCase())) return e.identity;
    }
  }]);
  return ge;
}();
export { ge as default };